import firebase_api from '@/firebase/firebase_api'

import Championnat from "@/firebase/championnat/tirage"
import ChampionnatClassique from "@/firebase/championnatClassique/tirage"
const object = {
    options: {
        nbJoueursParPool: 4,
        nbMinJoueursParPool: 3,
        nbJoueurs: 0,
        nbTourPool: 1
    },
    equipeJson: {
        joueurs: {
            J1: {numero: null, error: false, errorDetail: []},
            J2: null,
            J3: null
        },
        contre: {
            J1: {numero: null, error: false, errorDetail: []},
            J2: null,
            J3: null
        },
        state: "WAITING",
        score: {
            contre : null,
            joueurs : null
        },
        pool: null
    },
    getDate() {
        var dateCurrent = new Date();
        return dateCurrent;
    },
    setCoequipiers(equipeVS, tournoi) {
        
        var indexJoueurMeneur = equipeVS.J1.numero;
        var joueurJson1 = {
            numero: null,
            error: false,
            errorDetail: []
        }
        var joueurJson2 = {
            numero: null,
            error: false,
            errorDetail: []
        }
        if (indexJoueurMeneur!=null) {
            var joueurTournoiCoequipiers = tournoi.joueurs[indexJoueurMeneur];
            if (joueurTournoiCoequipiers.coequipier1!=null) {
                var idCoequipier1 = joueurTournoiCoequipiers.coequipier1;
                var indexJoueurCoequipier1 = tournoi.joueurs.findIndex(elt=>elt.id === idCoequipier1);
                joueurJson1.numero = indexJoueurCoequipier1;
                equipeVS.J2 = joueurJson1;
            }
            if (joueurTournoiCoequipiers.coequipier2!=null) {
                var idCoequipier2 = joueurTournoiCoequipiers.coequipier2;
                var indexJoueurCoequipier2 = tournoi.joueurs.findIndex(elt=>elt.id === idCoequipier2);
                joueurJson2.numero = indexJoueurCoequipier2;
                equipeVS.J3 = joueurJson2;
                }
        }
    },
    async setScore (club, tournoi, indexPartie, equipe, fct) {
      
        var batch = firebase_api.api.getDb().batch();
        var tournoiDB = firebase_api.api.getDb().collection("club").doc(club.id).collection("tournois").doc(tournoi.id);
        var tournoiDoc = await tournoiDB.get();
        var tournoiData = tournoiDoc.data();
        var partieDB = tournoiDB.collection("parties").doc("P"+indexPartie);
        var equipeDB = await partieDB.collection("equipes").doc(equipe.id);
        var AllEquipesDB = await partieDB.collection("equipes");
        var partieDocDATA = await partieDB.get();
        var partieData = await partieDocDATA.data();
        var leGagnant=null;
        var lePerdant=null;
      
        if (typeof(partieData.qualifie)=="undefined") {
            partieData.qualifie = [];
        }
        if (typeof(partieData.notQualifie)=="undefined") {
            partieData.notQualifie = [];
        }
        if (equipe.score["joueurs"]!=null) {
            if (equipe.score["joueurs"]>equipe.score["contre"]) {
                leGagnant = equipe.joueurs.J1.numero;
                lePerdant = equipe.contre.J1.numero;
            }
            else {
                leGagnant = equipe.contre.J1.numero;
                lePerdant = equipe.joueurs.J1.numero;
            }
            if (leGagnant!=null && partieData.qualifie.indexOf(leGagnant)==-1)
                partieData.qualifie.push(parseInt(leGagnant))

            if (lePerdant!=null && partieData.notQualifie.indexOf(leGagnant)==-1)
                partieData.notQualifie.push(parseInt(lePerdant))
        }
        else {
            delete equipe.joueurs.J1.qualifie;
            delete equipe.contre.J1.qualifie;
            var indexJoueur = partieData.qualifie.indexOf(parseInt(equipe.joueurs.J1.numero))
            if (indexJoueur != -1)
                partieData.qualifie.splice(indexJoueur, 1);

            indexJoueur = partieData.notQualifie.indexOf(parseInt(equipe.contre.J1.numero))
            if (indexJoueur != -1)
                partieData.notQualifie.splice(indexJoueur, 1);

            indexJoueur =  partieData.notQualifie.indexOf(parseInt(equipe.joueurs.J1.numero))

            if (indexJoueur != -1)
                partieData.notQualifie.splice(indexJoueur, 1);
            
            indexJoueur =  partieData.notQualifie.indexOf(parseInt(equipe.contre.J1.numero))
            
            if (indexJoueur != -1)
                partieData.notQualifie.splice(indexJoueur, 1);  
        }
        var allEquipesDoc = await AllEquipesDB.get();
       
        var toujoursInPROGRESS = false;
        var scoreOtherTeamIsNull = false;
        for (var indexEquipeDoc in allEquipesDoc.docs) {
            var equipeData = await allEquipesDoc.docs[indexEquipeDoc].data();
            if (equipeData.score.joueurs == null && allEquipesDoc.docs[indexEquipeDoc].id != equipe.id) {
                toujoursInPROGRESS = true;
            }
            else if (equipe.score.joueurs == null && allEquipesDoc.docs[indexEquipeDoc].id == equipe.id) {
                toujoursInPROGRESS = true;
            }
            if (equipeData.contre.J1.numero == null && equipeData.pool == indexPool) {
                partieData.qualifie.push(parseInt(equipeData.joueurs.J1.numero));
            }
           
        }
        //toujoursInPROGRESS = nbEquipes == allEquipesDoc.docs.length ? toujoursInPROGRESS : true;

        var state = toujoursInPROGRESS ? "INPROGRESS" : "FINISH";
   
        batch.update(partieDB, {
            state : state,
            qualifie: partieData.qualifie,
            notQualifie : partieData.notQualifie
        })
        var equipeData = JSON.parse(JSON.stringify(equipe));
        if (equipeData.score.joueurs == null)
            equipeData.state = "WAITING";
        else
            equipeData.state = "FINISH";
        await batch.set(equipeDB, equipeData);

        batch.commit().then(()=> {
          
            fct();
         //   console.log("after commit="+this.getDate());  
         });


    },
  
    async setScorePool (club, tournoi, indexPartie, equipe, fct) {
       
        

        var tournoiDB = firebase_api.api.getDb().collection("club").doc(club.id).collection("tournois").doc(tournoi.id);
        var tournoiDoc = await tournoiDB.get();
        var tournoiData = tournoiDoc.data();
       
        var nbEquipes = Object.keys(tournoiData.pools).length * 2;
        var partieDB = tournoiDB.collection("parties").doc("P"+indexPartie);
        var indexPool = equipe.pool;
        
        var equipeDB = await partieDB.collection("equipes").doc(equipe.id);
        var AllEquipesDB = await partieDB.collection("equipes")
        
        var partieDocDATA = await partieDB.get();
        var partieDATA = await partieDocDATA.data();
        var pools = partieDATA.pools;
        
        var inPool = false
        if (indexPartie>=0 && indexPartie<3) {
            inPool = true
        }
        if (indexPartie>=0 && indexPartie<3) {
            if (typeof(pools)=="undefined")
                pools= {};

            if (typeof(pools[equipe.pool])=="undefined") {
                pools[indexPool] = {
                    gagnants: [],
                    perdants:[]
                }
            }
        }
        
        var leGagnant=null;
        var lePerdant=null;
        // Si le score est différents null
        // Alors il faut que je mets les gagnants dans pool et les perdants
        if (equipe.score["joueurs"]!=null) {
            if (equipe.score["joueurs"]>equipe.score["contre"]) {
                leGagnant = equipe.joueurs.J1.numero;
                lePerdant = equipe.contre.J1.numero;
            }
            else {
                leGagnant = equipe.contre.J1.numero;
                lePerdant = equipe.joueurs.J1.numero;
            }
            if (leGagnant!=null && pools[indexPool].gagnants.indexOf(leGagnant)==-1 && inPool)
                pools[indexPool].gagnants.push(leGagnant)

            if (lePerdant!=null && pools[equipe.pool].perdants.indexOf(leGagnant)==-1 && inPool)
                pools[indexPool].perdants.push(lePerdant)
        }
        else {
            // Si le score est à null
            // alors j'enlève les qualitife
            delete equipe.joueurs.J1.qualifie;
            delete equipe.contre.J1.qualifie;
            if (inPool) {
                var indexJoueur = pools[indexPool].gagnants.indexOf(equipe.joueurs.J1.numero)
                if (indexJoueur != -1)
                    pools[indexPool].gagnants.splice(indexJoueur, 1);

                indexJoueur = pools[indexPool].gagnants.indexOf(equipe.contre.J1.numero)
                if (indexJoueur != -1)
                    pools[indexPool].gagnants.splice(indexJoueur, 1);

                indexJoueur = pools[indexPool].perdants.indexOf(equipe.joueurs.J1.numero)

                if (indexJoueur != -1)
                    pools[indexPool].perdants.splice(indexJoueur, 1);
                
                    indexJoueur = pools[indexPool].perdants.indexOf(equipe.contre.J1.numero)
                
                    if (indexJoueur != -1)
                    pools[indexPool].perdants.splice(indexJoueur, 1);   
                
            }
        }
      
       
        var allEquipesDoc = await AllEquipesDB.get();
       
        var toujoursInPROGRESS = false;
        var scoreOtherTeamIsNull = false;
        // Du coup je regarde si toutes les éqiupes sont termines pour terminer la partie
        // par contre je ne vérifie pas la partie en cours et ça c'est bizard !!!!!!!!!!!!
        for (var indexEquipeDoc in allEquipesDoc.docs) {
            var equipeData = await allEquipesDoc.docs[indexEquipeDoc].data();
            
            if (equipeData.score.joueurs == null && allEquipesDoc.docs[indexEquipeDoc].id != equipe.id) {
                toujoursInPROGRESS = true;
            }
            else if (equipe.score.joueurs == null && allEquipesDoc.docs[indexEquipeDoc].id == equipe.id) {
                toujoursInPROGRESS = true;
            }
            if (equipeData.contre.J1.numero == null && equipeData.pool == indexPool) {
                if (pools[indexPool].gagnants.indexOf(equipeData.joueurs.J1.numero)==-1) {
                    pools[indexPool].gagnants.push(equipeData.joueurs.J1.numero);
                    pools[indexPool].perdants.push(null);
                }
            }
            if (equipeData.score.joueurs == null && equipeData.pool == indexPool && allEquipesDoc.docs[indexEquipeDoc].id != equipe.id)
                scoreOtherTeamIsNull = true;
            
        }
    
        toujoursInPROGRESS = nbEquipes == (allEquipesDoc.docs.length) ? toujoursInPROGRESS : true;
       
        var state = toujoursInPROGRESS ? "INPROGRESS" : "FINISH";
       
        // La on est dans les barrages
        if (indexPartie==2) {
            
            if (typeof(partieDATA.qualifie)=="undefined") 
                var qualifie = [];
            else
                var qualifie = partieDATA.qualifie;
            
            if (typeof(partieDATA.notQualifie)=="undefined") 
                var notQualifie = [];
            else
                var notQualifie = partieDATA.notQualifie;
            
                if (equipe.score["joueurs"]!=null) {
                    pools[indexPool].gagnants.forEach(gagnant=>{
                        if (qualifie.indexOf(gagnant)==-1)
                           qualifie.push(gagnant);
                    })
                    pools[indexPool].perdants.forEach(perdant=>{
                        if (qualifie.indexOf(perdant)==-1)
                            notQualifie.push(perdant);
                    })
                }
                else {
                      var indexJoueur = qualifie.indexOf(parseInt(equipe.joueurs.J1.numero));
                      if (indexJoueur!=-1)
                        qualifie.splice(indexJoueur, 1);
                      
                      var indexJoueur = qualifie.indexOf(parseInt(equipe.contre.J1.numero));
                      if (indexJoueur!=-1)
                        qualifie.splice(indexJoueur, 1);
                     
                      var indexJoueur = notQualifie.indexOf(parseInt(equipe.joueurs.J1.numero));
                     if (indexJoueur!=-1)
                        notQualifie.splice(indexJoueur, 1);

                    var indexJoueur = notQualifie.indexOf(parseInt(equipe.contre.J1.numero));
                    if (indexJoueur!=-1)
                        notQualifie.splice(indexJoueur, 1);
                }

        }
        // je mets l'état et les poules des parties
        // là on est dans les poules
        if (inPool) {
            if (indexPartie<2) {
                partieDB.update({
                    pools: pools,
                    state : state
                })
            }
            else {
                partieDB.update({
                    pools: pools,
                    state : state,
                    qualifie: qualifie,
                    notQualifie : notQualifie
                })
            }
        }
        else {
            partieDB.update({
                state : state
            })
        }
      
        var gagne2parties = null;
        var gagne0parties = null;
        var gagne1partie = [];

        if (indexPartie >= 0 &&  indexPartie < 3) {
            if (indexPartie > 0) {
                var indexPrecPartie = parseInt(indexPartie) - 1;
                var partieDB = tournoiDB.collection("parties").doc("P"+indexPrecPartie);
                var equipeDBPrec = partieDB.collection("equipes").doc("E_"+indexPool+"_0");
                
                // Là je regarde actuelle !
                var pasDeScore = equipe.score.joueurs == null;
                
                //if (indexPartie!=2) // On ne tient pas compte du score de l'autre équipe du coup car on est dans les barrages
                //    pasDeScore = pasDeScore ?  scoreOtherTeamIsNull : pasDeScore;
                // j'enlève ca car c 'est par nomal
                /*var state;
                if (pasDeScore)
                    state="FINISH"
                else
                    state="WAITING"

                equipeDBPrec.update({
                    lock: !pasDeScore,
                    state: state
                })
                var equipeDBPrec = partieDB.collection("equipes").doc("E_"+indexPool+"_1");
                equipeDBPrec.update({
                    lock: !pasDeScore,
                    state: state
                })*/
             
                equipeDBPrec.update({
                    lock: !pasDeScore
                })
                var equipeDBPrec = partieDB.collection("equipes").doc("E_"+indexPool+"_1");
                equipeDBPrec.update({
                    lock: !pasDeScore
                })

                var partieDocDB = await partieDB.get();
                var partieData = partieDocDB.data();
                var gagnantsTOURM1 = partieData.pools[indexPool].gagnants;
                var perdantsTOURM2 = partieData.pools[indexPool].perdants;
                
                gagnantsTOURM1.forEach(gagnant=>{
                    if (pools[indexPool].gagnants.indexOf(gagnant)!=-1) {
                        gagne2parties = gagnant;
                        if (equipe.joueurs.J1.numero == gagnant)
                            equipe.joueurs.J1.qualifie = true;
                        if (equipe.contre.J1.numero == gagnant)
                            equipe.contre.J1.qualifie = true;
                    }
                    if (pools[indexPool].perdants.indexOf(gagnant)!=-1) {
                        gagne1partie.push(gagnant)
                    }
                })
                perdantsTOURM2.forEach(perdant=>{
                    if (pools[indexPool].perdants.indexOf(perdant)!=-1) {
                        gagne0parties = perdant;
                        if (equipe.joueurs.J1.numero == perdant)
                            equipe.joueurs.J1.qualifie = false;
                        if (equipe.contre.J1.numero == perdant)
                            equipe.contre.J1.qualifie = false;
                    }
                    if (pools[indexPool].gagnants.indexOf(perdant)!=-1) {
                        gagne1partie.push(perdant)
                    }
                })
            //    console.log("G="+this.getDate());  
            }
            if (equipe.score.joueurs == null) {
                var indexNextPartie = parseInt(indexPartie) + 1;
                var partieDB = tournoiDB.collection("parties").doc("P"+indexNextPartie);
                var partieDocDB = await partieDB.get();
                if (partieDocDB.exists) {
                    var equipeDBNEXT = partieDB.collection("equipes").doc("E_"+indexPool+"_0");
                    equipeDBNEXT.delete();
                    equipeDBNEXT = partieDB.collection("equipes").doc("E_"+indexPool+"_1");
                    equipeDBNEXT.delete();
                }
            }
           // console.log("H="+this.getDate());  
        }
        var equipeData = JSON.parse(JSON.stringify(equipe));
        if (equipeData.score.joueurs == null)
            equipeData.state = "WAITING";
        else
            equipeData.state = "FINISH";
        
        equipeDB.set(equipeData);
       
        
        // ici on créer les poules dans la partie suivante
        if (indexPartie == 0) {
            if (pools[indexPool].gagnants.length == 2) {
                var indexNextPartie = parseInt(indexPartie) + 1;
                var partieDB = tournoiDB.collection("parties").doc("P"+indexNextPartie);
                var partieDocDB = await partieDB.get();
                if (!partieDocDB.exists) {
                    partieDB.set({
                        type:"TOUR2",
                        state:"WAITING"
                    })
                }
                // faut vérifie car il n'existe pas il faut le créer !
                var equipeDBNext = partieDB.collection("equipes").doc("E_"+indexPool+"_0");
                var equipeNew = JSON.parse(JSON.stringify(this.equipeJson));
                equipeNew.joueurs.J1.numero = pools[indexPool].gagnants[0];
                equipeNew.contre.J1.numero = pools[indexPool].gagnants[1];
                equipeNew.pool = indexPool;
                this.setCoequipiers(equipeNew.joueurs, tournoi);
                this.setCoequipiers(equipeNew.contre, tournoi);
                equipeDBNext.set(equipeNew);
            }
            if (pools[equipe.pool].perdants.length == 2) {
                var indexNextPartie = parseInt(indexPartie) + 1;
                var partieDB = tournoiDB.collection("parties").doc("P"+indexNextPartie);
                var partieDocDB = await partieDB.get();
                if (!partieDocDB.exists) {
                    partieDB.set({
                        type:"TOUR2",
                        state:"WAITING"
                    })
                }
                var equipeDBNext = partieDB.collection("equipes").doc("E_"+indexPool+"_1");
                var equipeNew = JSON.parse(JSON.stringify(this.equipeJson));
                if (pools[indexPool].perdants[0] == null) {
                    equipeNew.joueurs.J1.numero = pools[indexPool].perdants[1];
                    equipeNew.contre.J1.numero = pools[indexPool].perdants[0];
                }
                else {
                    equipeNew.joueurs.J1.numero = pools[indexPool].perdants[0];
                    equipeNew.contre.J1.numero = pools[indexPool].perdants[1];
                }
                
                equipeNew.pool = indexPool;
                if (equipeNew.contre.J1.numero == null) {
                    equipeNew.score["joueurs"]=13;
                    equipeNew.score["contre"]=7;
                    equipeNew.state = "FINISH";
                }
                this.setCoequipiers(equipeNew.joueurs, tournoi);
                this.setCoequipiers(equipeNew.contre, tournoi);
                equipeDBNext.set(equipeNew)
            }
        }
        else if (indexPartie==1) {
            if (pools[indexPool].gagnants.length == 2) {
                var indexNextPartie = parseInt(indexPartie) + 1;
                var partieDB = tournoiDB.collection("parties").doc("P"+indexNextPartie);
                var partieDocDB = await partieDB.get();
                
                
                if (!partieDocDB.exists) {
                    var pools = {};
                    pools[indexPool] = {
                        gagnants: [],
                        perdants: []
                    }
                    pools[indexPool].gagnants.push(gagne2parties);
                    pools[indexPool].perdants.push(gagne0parties);
                    partieDB.set({
                        type:"BARRAGE",
                        state:"WAITING",
                        pools: pools
                    })
                }
                else {
                    var partieDataNext = partieDocDB.data();
                    var pools = partieDataNext.pools;
                    if (typeof(pools[indexPool])=="undefined") {
                        pools[indexPool] = {
                            gagnants: [],
                            perdants: []
                        }
                    }
                    pools[indexPool].gagnants.push(gagne2parties);
                    pools[indexPool].perdants.push(gagne0parties);
                    partieDB.update({
                        pools: pools
                    })
                }
              //  console.log("K="+this.getDate());  
                var equipeDBNext = partieDB.collection("equipes").doc("E_"+indexPool+"_0");
                var equipeNew = JSON.parse(JSON.stringify(this.equipeJson));
                equipeNew.joueurs.J1.numero = gagne2parties;
                equipeNew.joueurs.J1.qualifie = true;
                equipeNew.contre.J1.numero = gagne0parties;
                equipeNew.contre.J1.qualifie = false;
                equipeNew.pool = indexPool;
                equipeNew.score.joueurs = 13;
                equipeNew.score.contre = 7;
                equipeNew.state = "FINISH";
                this.setCoequipiers(equipeNew.joueurs, tournoi);
                this.setCoequipiers(equipeNew.contre, tournoi);
                equipeDBNext.set(equipeNew);
                
                
                var equipeDBNext = partieDB.collection("equipes").doc("E_"+indexPool+"_1");
                var equipeNew = JSON.parse(JSON.stringify(this.equipeJson));
                equipeNew.joueurs.J1.numero = gagne1partie[0];
                equipeNew.contre.J1.numero = gagne1partie[1];
                equipeNew.pool = indexPool;
                this.setCoequipiers(equipeNew.joueurs, tournoi);
                this.setCoequipiers(equipeNew.contre, tournoi);
                equipeDBNext.set(equipeNew);
            }
        }
        
        fct();
    },

    async jsonPartiesToDbPool (club, tournoi, type, indexPartie, jsonData) {
        var tournoiDB = firebase_api.api.getDb().collection("club").doc(club.id).collection("tournois").doc(tournoi.id);
        var partieDB = tournoiDB.collection("parties").doc("P"+indexPartie);
        await partieDB.set({
            type: type,
            state: "WAITING"
        });
        
        for(var indexPool in jsonData) {
            var jsonDataPool = jsonData[indexPool].parties[indexPartie];
            for (var indexEquipe in jsonDataPool.equipes) {
                var equipe = jsonDataPool.equipes[indexEquipe];
              
                this.setCoequipiers(equipe.joueurs, tournoi);
                this.setCoequipiers(equipe.contre, tournoi);
                await partieDB.collection("equipes").doc("E_"+indexPool+"_"+indexEquipe).set(equipe);
            }
        }
    },
    async jsonPartiesToDbOnePool (club, tournoi, type, indexPartie, indexPool, jsonData) {
        var tournoiDB = firebase_api.api.getDb().collection("club").doc(club.id).collection("tournois").doc(tournoi.id);
        var partieDB = tournoiDB.collection("parties").doc("P"+indexPartie);
        await partieDB.set({
            type: type,
            state: "WAITING"
        });
        var jsonDataPool = jsonData[indexPool].parties[indexPartie];
        if (typeof(jsonDataPool)!="undefined") {
           
            for (var indexEquipe in jsonDataPool.equipes) {
                var equipe = jsonDataPool.equipes[indexEquipe];
                    this.setCoequipiers(equipe.contre, tournoi);
                    await  partieDB.collection("equipes").doc("E_"+indexPool+"_"+indexEquipe).set(equipe);
            }
        }
    },
    async jsonPartiesToDbWithOutPool (club, tournoi, type, indexPartie, indexPool, jsonData) {
        var tournoiDB = firebase_api.api.getDb().collection("club").doc(club.id).collection("tournois").doc(tournoi.id);
        var partieDB = tournoiDB.collection("parties").doc("P"+indexPartie);
        var nbEquipes = jsonData.equipes.length;
     
        var name = "ELIMINATOIRE";
        if (nbEquipes == 1)
            name = "FINALE";
        else if (nbEquipes == 2)
            name = "DEMI FINALE"
        else if (nbEquipes == 4)
            name =  "QUART de FINALE"
        else if (nbEquipes == 8)
            name =  "8ème de FINALE"
        else if (nbEquipes == 16)
            name =  "16ème de FINALE"
        else if (nbEquipes == 32)
            name =  "32ème de FINALE"
        else    
            name =  "ELIMINATOIRE"

     
        await partieDB.set({
            type: type,
            state: "WAITING",
            name: name
        });
        
        for (var indexEquipe in jsonData.equipes) {
            var equipe = jsonData.equipes[indexEquipe];
            this.setCoequipiers(equipe.joueurs, tournoi);
            this.setCoequipiers(equipe.contre, tournoi);
            await partieDB.collection("equipes").doc("E_"+indexPool+"_"+indexEquipe).set(equipe);
        }
    },
    async init(club, tournoi, nbEquipes, nbPools) { // TOUR1
       
        var tournoiDB = firebase_api.api.getDb().collection("club").doc(club.id).collection("tournois").doc(tournoi.id);
        this.options.nbJoueurs = nbEquipes;
        if (tournoi.options.championnat.type == 'gg') {
            var tirage = new Championnat(this.options);
            // J'initialise les joueurs dans les poules 
            tirage.initPools(nbPools);
            // là j'initialise les équipes
            tirage.init();
            
            var jsonChampionnat = tirage.getJson();
            this.jsonPartiesToDbPool (club, tournoi, "TOUR1", 0, jsonChampionnat);
        }
        else {
            var tirage = new ChampionnatClassique(this.options);
            // J'initialise les joueurs dans les poules 
            tirage.initPools(nbPools);
            // là j'initialise les équipes
            tirage.init();
            
           
            var jsonChampionnat = tirage.getJson();
         
            this.jsonPartiesToDbPool (club, tournoi, "TOUR1", 0, jsonChampionnat);
            this.jsonPartiesToDbPool (club, tournoi, "TOUR2", 1, jsonChampionnat);
            this.jsonPartiesToDbPool (club, tournoi, "TOUR3", 2, jsonChampionnat);
        }
        
        var pools = {}
        await jsonChampionnat.forEach(async (poolItem, indexPool)=>{
            pools[indexPool] = poolItem.joueurs;
        })
        await tournoiDB.set({
            pools: pools,
            state: 'INPROGRESS',
            joueurs: tournoi.joueurs,
            options: tournoi.options
        }, {merge: true})
    },
    async tour2 (club, tournoi, indexPoolRefresh) {
        var jsonChampionnat = await this.constructJsonChampionnat(club, tournoi);
        var nbEquipes=0;
        jsonChampionnat.forEach(poolItem=>{
            nbEquipes+=poolItem.joueurs.length;
        })
        this.options.nbJoueurs = nbEquipes;
        var tirage = new Championnat(this.options);
        tirage.reinitPool( jsonChampionnat );
        tirage.init_TOUR2();
        var jsonChampionnat2 = tirage.getJson();
        
        await this.jsonPartiesToDbOnePool (club, tournoi, "TOUR2", 1, indexPoolRefresh, jsonChampionnat2);
    },
    
    async barrage (club, tournoi, indexPoolRefresh) {
        var jsonChampionnat = await this.constructJsonChampionnat(club, tournoi);
        var nbEquipes=0;
        jsonChampionnat.forEach(poolItem=>{
            nbEquipes+=poolItem.joueurs.length;
        })
        this.options.nbJoueurs = nbEquipes;
        var tirage = new Championnat(this.options);
        tirage.reinitPool( jsonChampionnat );
        tirage.init_BARAGE();
        var jsonChampionnat2 = tirage.getJson();
        await this.jsonPartiesToDbOnePool (club, tournoi, "BARRAGE", 2, indexPoolRefresh, jsonChampionnat2);
    },
    async cadrage (club, tournoi, nbEquipes, indexPartie) {
        var optionChampionnat = {
            nbJoueursParPool: 4,
            nbMinJoueursParPool: 3,
            nbJoueurs: nbEquipes,
            nbTourPool: 1
        }
        var completeJoueurs=[];
        var equipeCadrage=[];
        var tournoiDB = firebase_api.api.getDb().collection("club").doc(club.id).collection("tournois").doc(tournoi.id);
        var indexPartiePrec = indexPartie-1;
        var partieDBPrec =  tournoiDB.collection("parties").doc("P"+indexPartiePrec);
        var partieDBPrecDoc = await partieDBPrec.get();
        var partiePrecData = await partieDBPrecDoc.data();

        

        var tirage = new Championnat(optionChampionnat);
        if (indexPartie==2) {
            var jsonQualifie = await this.whoIsQualified(club, tournoi);
            tirage.addCadrage(jsonQualifie);
        }
        else {
            
            tirage.eliminatoire[0] = {
                joueurs: [],
                equipes: []
            }
           
            tirage.eliminatoire[0].joueurs =  partiePrecData.qualifie.slice();
           
            tirage.addCadrage();
        }
        
        
        var jsonEliminatoire = tirage.getJsonEliminatoire();
     
        var indexJson = jsonEliminatoire.length - 1;
        if (jsonEliminatoire.length!=0) {
            jsonEliminatoire[indexJson].equipes.forEach(equipe=>{
                if (equipe.joueurs.J1.numero!=null)
                    equipeCadrage.push(parseInt(equipe.joueurs.J1.numero));
                if (equipe.contre.J1.numero!=null)
                    equipeCadrage.push(parseInt(equipe.contre.J1.numero));
                })
               
                partiePrecData.qualifie.forEach(numero=>{
                    if (equipeCadrage.indexOf(numero)==-1) 
                        completeJoueurs.push(numero)
                })
                var partieDB = tournoiDB.collection("parties").doc("P"+indexPartie);
                await partieDB.set({
                    type: "CADRAGE",
                    state: "WAITING",
                    completeJoueurs: completeJoueurs
                });
                
                for (var indexEquipe in  jsonEliminatoire[indexJson].equipes) {
                    var equipe = jsonEliminatoire[indexJson].equipes[indexEquipe];
                    this.setCoequipiers(equipe.joueurs, tournoi);
                    this.setCoequipiers(equipe.contre, tournoi);
                    await partieDB.collection("equipes").doc("E_"+indexEquipe).set(equipe);
                };
                
                tournoi.cadrage = true;
                await tournoiDB.set({
                    cadrage: true
                }, {merge: true});
                
        }
        
    },
    async eliminatoireClassique (club, tournoi, poule, indexPartie) {
       
       
        var tirage = new ChampionnatClassique(tournoi.options);
        var jsonData = tirage.eliminatoireClassique(poule);
        // Pour être raccort avec l'autre tournoi en mode GG, il faut faire comme si, le cadrage a été effectué
        // Sinon la phase d'éiminatoire ne va pas se crée au fil des scores
        tournoi.cadrage = true;
        var pouleConstruct = [];
        poule.forEach((itemPoule, indexPoule)=>{
            pouleConstruct[indexPoule] = {};
            itemPoule.forEach((equipe, indexEquipe)=>{
                pouleConstruct[indexPoule][equipe.numero]=equipe;
            })
        })
        tournoi.options.resultatPoule = pouleConstruct;
        

        var tournoiDB = firebase_api.api.getDb().collection("club").doc(club.id).collection("tournois").doc(tournoi.id);
        await tournoiDB.set({
            cadrage: true,
            options: tournoi.options
        }, {merge: true});
        await this.jsonPartiesToDbWithOutPool(club, tournoi, "ELIMINATOIRE", indexPartie+1, 0, jsonData);
    },
    async eliminatoire (club, tournoi, indexPartie) {
        
        var tournoiDB = firebase_api.api.getDb().collection("club").doc(club.id).collection("tournois").doc(tournoi.id);
        var partieDB = tournoiDB.collection("parties").doc("P"+indexPartie);
        var partieDoc = await partieDB.get();
        var partieData = await partieDoc.data();
        var listReelQualifie = [];
        if (partieData.type=="CADRAGE") {
            // ATTENTION la dernière partie est cadrage !!!!!
            // Il faut donc reprendre la partie d'avant + les gagnants du cadrage
            // et refaire une partie éliminatoire
            // Attention il se peut que la partie d'avant ce soit le barrage
            listReelQualifie = partieData.qualifie;
            partieData.completeJoueurs.forEach(joueur=>{
                listReelQualifie.push(joueur);
            })
            var jsonEquipes = {
               equipes: Championnat.initSimpleEliminatoire (listReelQualifie)
            }
            
            var indexNewPartie = parseInt(indexPartie)+1;

            await this.jsonPartiesToDbWithOutPool (club, tournoi, "ELIMINATOIRE", indexNewPartie, 0, jsonEquipes);
        }
        else if (partieData.type=="BARRAGE") {
            var optionChampionnat = {
                nbJoueursParPool: 4,
                nbMinJoueursParPool: 3,
                nbJoueurs: 0,
                nbTourPool: 1
            }
            var tirage = new Championnat(optionChampionnat);
            var jsonChampionnat = await this.constructJsonChampionnat(club, tournoi);
            tirage.reinitPool( jsonChampionnat);
            var jsonQualifie = tirage.qualifie();
            tirage.initEliminatoire(jsonQualifie);
           
            var jsonEliminatoire = tirage.getJsonEliminatoire();
            var indexNewPartie = parseInt(indexPartie)+1;
            await this.jsonPartiesToDbWithOutPool (club, tournoi, "ELIMINATOIRE", indexNewPartie, 0, jsonEliminatoire[0]);
        }
        else if (partieData.type=="ELIMINATOIRE") {
        
            var equipesDOC = await partieDB.collection("equipes").get();
            var jsonEliminatoire = [];

            jsonEliminatoire[0] = {
                equipes:[],
                joueurs:[]
            }
            var indexJoueur = 0;
            for (var indexEquipe in equipesDOC.docs) {
                jsonEliminatoire[0].equipes[indexEquipe] = equipesDOC.docs[indexEquipe].data();
                jsonEliminatoire[0].joueurs[indexJoueur] = jsonEliminatoire[0].equipes[indexEquipe].joueurs.J1;
                indexJoueur++;
                jsonEliminatoire[0].joueurs[indexJoueur] = jsonEliminatoire[0].equipes[indexEquipe].contre.J1;
                indexJoueur++;
            }
           
            var optionChampionnat = {
                nbJoueursParPool: 4,
                nbMinJoueursParPool: 3,
                nbJoueurs: indexJoueur,
                nbTourPool: 1
            }
            var tirage = new Championnat(optionChampionnat);
            tirage.reinitEliminatoire(jsonEliminatoire);
            
            tirage.setEliminatoire(1);

        // console.log(tirage.getJsonEliminatoire());
            
            var newJsonEliminatoire = tirage.getJsonEliminatoire();
          
            if (newJsonEliminatoire[1].equipes.length>0) {
                var indexNewPartie = parseInt(indexPartie)+1;
                await this.jsonPartiesToDbWithOutPool (club, tournoi, "ELIMINATOIRE", indexNewPartie, 0, newJsonEliminatoire[1]);
            }
        
            
        }

    },
    
    async whoIsQualified (club, tournoi) {
        return new Promise (async resolve=>{
            var jsonChampionnat = await this.constructJsonChampionnat(club, tournoi);
          
            var nbEquipes=0;
            jsonChampionnat.forEach(poolItem=>{
                nbEquipes+=poolItem.joueurs.length;
                
            })
            
            this.options.nbJoueurs = nbEquipes;
            var tirage = new Championnat(this.options);
            tirage.reinitPool( jsonChampionnat );
        
            var jsonChampionnat2 = tirage.qualifie();
          
            resolve(jsonChampionnat2);
        })
    },
    async constructJsonChampionnat(club, tournoi) {
        var jsonChampionnat=[];
        var joueursPool={};
       
        return new Promise (async resolve=>{
            
            var tournoiDB = await firebase_api.api.getDb().collection("club").doc(club.id).collection("tournois").doc(tournoi.id);
            var tournoiDoc = await tournoiDB.get();
            var tournoiData = tournoiDoc.data();
            joueursPool = tournoiData.pools;
            
            var partiesDocs = await tournoiDB.collection("parties").get();
            var partiesDocsData = partiesDocs.docs
           
            
            for (var indexPartie in partiesDocsData) {
              
                var equipesDoc = await partiesDocsData[indexPartie].ref.collection("equipes").orderBy("pool").get();
                
                var equipesDocData = equipesDoc.docs;
                var indexPool = null;
                var indexEquipeReel = 0;
                for (var indexEquipe in equipesDocData) {
                
                    var equipeData = equipesDocData[indexEquipe].data();
                    if (indexPool!=equipeData.pool) {
                        indexEquipeReel=0;
                        indexPool = equipeData.pool;
                    }
                   
                    if (typeof(jsonChampionnat[equipeData.pool]) == "undefined") {
                        jsonChampionnat[equipeData.pool] = {
                            parties: [],
                            joueurs: joueursPool[equipeData.pool]
                            }
                    }
                    if (typeof(jsonChampionnat[equipeData.pool].parties[indexPartie])=="undefined") {
                        jsonChampionnat[equipeData.pool].parties[indexPartie] = {
                            equipes: []
                        }
                    }
                    var equipeCopy= JSON.parse(JSON.stringify(equipeData));
                   
                  
                    jsonChampionnat[equipeData.pool].parties[indexPartie].equipes[indexEquipeReel] = equipeCopy;
                    indexEquipeReel ++;
                }
             
            }
            
          
            resolve(jsonChampionnat);
        })
    }
    
}

export default {
    object: object
}